import React from 'react';
import ExpandedText from '../../../../../common/helpers/expanded_text';
import { SvgIcon } from '../../../../../common/sprites';
import { isWebView, isPS } from '../../../../../common/config/utils';
import {
  getAdvisorCTABtnClassName,
  getAltMessage,
  getModeTitle,
  getImage,
  renderPrice
} from './advisor_cta_utils';
import {
  getBGColor,
  getModeShadowColor,
  getModeStatusColor,
  getModeTitleColor,
  modeStatusStrings
} from './style_config';
import classes from './classes.module.scss';
import { advisorCtaThemes } from './advisor_cta_themes';

export function DefaultAdvisorCTA({
  theme,
  mode,
  modeState,
  liveModes,
  name,
  t,
  localPromoPrices,
  localPrice,
  userAdvisorModeSalePrice,
  currency,
  advisorCTAOnClick,
  freeMinLabel,
  modeUnavailablePoppupVisible,
  renderModeUnavailablePoppup
}) {
  return (
    <button
      onKeyDown={ e => { e.preventDefault(); } }
      type="button"
      onClick={ (event) => advisorCTAOnClick({ e: event }) }
      className={ getAdvisorCTABtnClassName({ theme }) }
      style={ { backgroundColor: getBGColor(mode, modeState), ...getModeShadowColor({ modeState }) } }
    >
      { freeMinLabel }
      <SvgIcon className={ classes.modeImage } id={ `${ getImage({ mode, modeState, liveModes }) }` } title={ getAltMessage({ mode }) } />
      <div className={ classes.pricesContainer }>
        <span className={ classes.modeTitle } style={ { ...getModeTitleColor(modeState, mode) } }>
          <ExpandedText
            customClasses={ { text: classes.modeTitle } }
            ellipsis
          >
            { getModeTitle({ name, mode, t }) }
          </ExpandedText>
        </span>
        { renderPrice({
          localPromoPrices, localPrice, userAdvisorModeSalePrice, modeState, mode, currency
        }) }
        {isPS() && modeState === 'online' && theme !== advisorCtaThemes.advisorFixContainer && (
        <span
          className={ classes.psStartPill }
          style={ getModeStatusColor({ mode, modeState, liveModes }) }
        >
          {t('chat.start')}
        </span>
        )}
      </div>
      <span className={ classes.modeStatus } style={ { ...getModeStatusColor({ mode, modeState, liveModes }) } }>
        {isWebView() && t(modeStatusStrings[modeState])}
      </span>
      { modeUnavailablePoppupVisible && renderModeUnavailablePoppup() }
    </button>
  );
}
